import type {
  AnalyticsEvent,
  UserProperties,
  PageViewData,
  PentictonEventsTracking,
} from '../types';

export abstract class AnalyticsProvider {
  protected enabled: boolean;
  protected debug: boolean;
  protected consentGranted: boolean;

  constructor(enabled: boolean = true, debug: boolean = false) {
    this.enabled = enabled;
    this.debug = debug;
    this.consentGranted = false;
  }

  abstract initialize(): Promise<void>;
  abstract trackEvent<T extends keyof PentictonEventsTracking>(
    eventName: T,
    properties: PentictonEventsTracking[T],
  ): void;
  abstract trackPageView(data: PageViewData): void;
  abstract setUserProperties(properties: UserProperties): void;
  abstract setConsent(granted: boolean): void;

  protected log(message: string, data?: any): void {
    if (this.debug) {
      console.log(`[Analytics] ${message}`, data);
    }
  }

  protected shouldTrack(): boolean {
    return this.enabled && this.consentGranted;
  }
}
